/**
 * Password re-authentication for signatures (release, hold lift, disposal, recall): the person
 * types their own login password again; uc-core answers with a short-lived token the signature
 * call carries. The password is encrypted exactly as at login.
 */
import { z } from 'zod'
import { api } from '@/api'
import { encryptPassword } from '@/auth/passwordCipher'

const reauthSchema = z.looseObject({ reauth_token: z.string(), expires_at: z.string().nullish() })

/** POST /auth/reauth → the token to send as `reauthToken`. */
export async function reauthenticate(password: string): Promise<string> {
  const res = await api.post('/auth/reauth', { password: await encryptPassword(password) }, { schema: reauthSchema })
  return res.reauth_token
}
